module.exports = __webpack_public_path__ + "static/media/target-dummy.5ba7f7c4.svg";